import Inputs, { InputsGroup, InputLabel } from "Components/Inputs";
import { onKeyPressOnlyLetters } from "utils";

const FormUsuarios = ({
  profiles,
  marcas,
  operaciones,
  values,
  setValues,
  errors,
  action,
  textCurrentMarca
}: {
  profiles?: Array<any>;
  marcas?: Array<any>;
  operaciones: Array<any>;
  values: any;
  setValues: (values: any) => void;
  errors: any;
  action?: number;
  textCurrentMarca?: string
}) => {
  return (
    <div style={{ marginTop: 40, marginBottom: 40 }}>
      <InputsGroup pTB={errors?.correo ? "16px" : "20px"}>
        <>
          <Inputs
            label={"Correo"}
            type={"text"}
            className={`input `}
            handleOnChange={(e) =>
              setValues({ ...values, correo: e.target.value })
            }
            value={values?.correo ? values.correo : ""}
            errorMessage={errors?.correo}
            disable={values.idUsuario ? true : false}
          />

          {!values.idUsuario && (
            <Inputs
              label={"Contraseña"}
              type={"password"}
              className={`input `}
              handleOnChange={(e) =>
                setValues({ ...values, contrasenia: e.target.value })
              }
              value={values?.contrasenia ? values.contrasenia : ""}
              errorMessage={errors?.contrasenia}
            />
          )}
        </>
      </InputsGroup>
      <InputsGroup pTB={errors?.nombre ? "16px" : "20px"}>
        <Inputs
          label={"Nombre (s)"}
          type={"text"}
          className={`input `}
          handleOnChange={(e) => {
            let res = /^([^0-9]*)$/.test(e.target.value);
            if (!res) {
              return null;
            }
            setValues({ ...values, nombre: e.target.value });
          }}
          value={values?.nombre ? values.nombre : ""}
          errorMessage={errors?.nombre}
          disable={values.idUsuario ? true : false}
        />
      </InputsGroup>
      <InputsGroup
        pTB={errors?.apellidoPat || errors?.apellidoMat ? "16px" : "20px"}
      >
        <>
          <Inputs
            label={"Apellido paterno"}
            type={"text"}
            className={`input `}
            handleOnChange={(e) => {
              let res = /^([^0-9]*)$/.test(e.target.value);
              if (!res) {
                return null;
              }
              setValues({ ...values, apellidoPat: e.target.value });
            }}
            value={values?.apellidoPat ? values.apellidoPat : ""}
            errorMessage={errors?.apellidoPat}
            disable={values.idUsuario ? true : false}
          />

          <Inputs
            label={"Apellido materno"}
            type={"text"}
            className={`input `}
            handleOnChange={(e) => {
              let res = /^([^0-9]*)$/.test(e.target.value);
              if (!res) {
                return null;
              }
              setValues({ ...values, apellidoMat: e.target.value });
            }}
            value={values?.apellidoMat ? values.apellidoMat : ""}
            errorMessage={errors?.apellidoMat}
            disable={values.idUsuario ? true : false}
          />
        </>
      </InputsGroup>
      <InputsGroup
        pTB={
          errors?.idMarcaOrigen || errors?.idTipoOperOrigen ? "16px" : "20px"
        }
      >
        <>
          <div>
            {textCurrentMarca ? (
              <span
                style={{
                  position: "relative",
                  left: 25,
                  top: -15,
                  zIndex: 10,
                  fontSize: 12
                }}
              >
               La marca {textCurrentMarca} esta desactivada
              </span>
            ) : (
              ""
            )}
            <Inputs
              label={"Marca"}
              type={"select"}
              className={`input `}
              options={marcas}
              handleOnChange={(e) =>
                setValues({
                  ...values,
                  idMarcaOrigen: e.target.value,
                  idTipoOperOrigen: 0,
                })
              }
              value={values?.idMarcaOrigen ? values.idMarcaOrigen : ""}
              errorMessage={errors?.idMarcaOrigen}
              disable={action ? true : false}
            />
          </div>

          <Inputs
            label={"Tipo operación"}
            type={"select"}
            className={`input `}
            options={operaciones}
            handleOnChange={(e) =>
              setValues({ ...values, idTipoOperOrigen: e.target.value })
            }
            value={values?.idTipoOperOrigen ? values.idTipoOperOrigen : ""}
            errorMessage={errors?.idTipoOperOrigen}
            disable={action ? true : false}
          />
        </>
      </InputsGroup>
      <InputsGroup
        pTB={errors?.idEstatus || errors?.idPerfil ? "16px" : "20px"}
      >
        <>
          {!values.idUsuario && (
            <Inputs
              label={"Estatus"}
              type={"select"}
              className={`input `}
              options={[
                {
                  value: "",
                  text: "Selecciona una opción",
                },

                {
                  value: "false",
                  text: "Desactivado",
                },
                {
                  value: "true",
                  text: "Activo",
                },
              ]}
              handleOnChange={(e) =>
                setValues({ ...values, idEstatus: e.target.value })
              }
              value={values?.idEstatus}
              errorMessage={errors?.idEstatus}
            />
          )}

          <Inputs
            label={"Perfil"}
            type={"select"}
            className={`input `}
            options={profiles}
            handleOnChange={(e) =>
              setValues({ ...values, idPerfil: e.target.value })
            }
            value={values?.idPerfil ? values.idPerfil.toString() : ""}
            errorMessage={errors?.idPerfil}
            disable={action ? true : false}
          />
        </>
      </InputsGroup>
    </div>
  );
};

export default FormUsuarios;
